import { startTransition, StrictMode } from 'react';

import { logger } from '@web-platform/shared-travel-tools-utils-frontend';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import {
  EmotionCacheProvider,
  markHydrationError,
} from './components/EmotionCacheProvider/EmotionCacheProvider';

const HYDRATION_ERROR_KEYWORDS = [
  'Hydration',
  'hydrating',
  'did not match',
  'Text content does not match',
  'switch to client rendering',
  '418',
  '423',
  '425',
  '345',
];

const isHydrationError = (message: string): boolean =>
  HYDRATION_ERROR_KEYWORDS.some((keyword) => message.includes(keyword));

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <EmotionCacheProvider>
        <HydratedRouter />
      </EmotionCacheProvider>
    </StrictMode>,
    {
      onRecoverableError: (error, errorInfo) => {
        const errorMessage = error instanceof Error ? error.message : String(error);
        if (isHydrationError(errorMessage)) {
          logger.warn('Hydration mismatch likely caused by browser extension', {
            errorMessage,
            componentStack: errorInfo.componentStack ?? '',
          });
          markHydrationError();
        } else {
          logger.error(
            'Recoverable error during hydration',
            {
              errorMessage,
              componentStack: errorInfo.componentStack ?? '',
            },
            error,
          );
        }
      },
    },
  );
});
